import { ReactElement, useMemo } from 'react';
import { useCabinetText } from '../../../CabinetContext';
import { EVENT_TYPE, PAGE_URL, TIER, NEW_TIER, NEW_TIER_DETAILS } from '../../../constants';
import { trackEventWithExtra } from '../../../utils/appAnalyticsUtils';
import CabinetPromo from './CabinetPromo';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useNavigate } from 'react-router-dom';

interface ComponentProps {
  onClose: () => void;
}

type Props = ComponentProps;

const CabinetPromoContainer = ({ onClose }: Props): ReactElement => {
  const user = useSelector((state: RootState) => state.auth.user);

  const navigate = useNavigate();

  const userIsBasic = (user?.active_license.tier === NEW_TIER.BASIC);
  
  const [strategicDetails, coreDetails] = useCabinetText(
    ['onboard-strategic-features', 'onboard-core-features']);

  const planOptions = useMemo(() => {
    const plans = [];
    if (userIsBasic) {
      plans.push({
        tierKey: NEW_TIER.CORE,
        name: 'Core',
        monthlyPrice: NEW_TIER_DETAILS[NEW_TIER.CORE].monthlyPrice,
        annualPrice: NEW_TIER_DETAILS[NEW_TIER.CORE].annualPrice,
        buttonText: 'Try for Free',
        features: coreDetails,
      });
    }

    plans.push(
      {
        tierKey: NEW_TIER.STRATEGIC,
        name: 'Strategic',
        monthlyPrice: NEW_TIER_DETAILS[NEW_TIER.STRATEGIC].monthlyPrice,
        annualPrice: NEW_TIER_DETAILS[NEW_TIER.STRATEGIC].annualPrice,
        buttonText: 'Learn More',
        features: strategicDetails,
      },
    );
    return plans;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategicDetails.join(','), coreDetails.join(',')]);

  const handlePlanSelected = (tier: TIER) => {
    trackEventWithExtra(
      {eventName: EVENT_TYPE.PROMO_TIER_CLICKED, extra: {tier}}, 
      () => {
        navigate(PAGE_URL.MY_TEAM);
        onClose();
      }
    );
  };

  return <CabinetPromo planOptions={planOptions} onPlanSelected={handlePlanSelected} userIsBasic={userIsBasic} />;
};

export default CabinetPromoContainer;